import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dialog, DialogProps, DialogTitle, DialogContent, Grid, TextField, Box, Button, Switch, TableContainer, Table, TableCell, TableHead,TableRow, TableBody } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CsvUploader from "../../CSVUpload";
import CSVImg from "../../../asset/image/csv_icon.png";
import { Domain } from "@material-ui/icons";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadCSV, {DownloadNamedCSV} from "./../../DownloadCSV"
import AntSwitch from "../../AntSwitch";
import { toast } from "react-toastify";
interface Domain {
    domain: string
    sub_domain: boolean
}

const ContentFilterBlockedDomains = ({blockedDomains, setBlockedDomains, onSetBlockedDomains, handleFileUpload, blockedfileSelected, setBlockedFileSelected, blockedFileName, setBlockedFileName, csvFileBlockedDomains, setCSVFileBlockedDomains})=>{

    const [domainName, setDomainName] = useState<string>("")
    const [includeSubDomain, setIncludeSubDomain] = useState<boolean>(true)
    const [errorMessage, setErrorMessage] = useState<string>("")
    let sampleCSVData = [{
            "domain":"DOMAIN",
            "sub_domain":"SUB_DOMAIN"
        },
        {
            "domain":"example.com",
            "sub_domain":"TRUE"
        },
        {
            "domain":"test.com",
            "sub_domain":"FALSE"
        }
    ]   

    useEffect(()=>{
        onSetBlockedDomains(blockedDomains)
    }, [blockedDomains])

    const onChangeIncludeSubDomain = (event)=>{
        setIncludeSubDomain(event.target.checked)
    }

    const onChangeDomainName = (event)=>{
        setDomainName(event.target.value)
    }

    const addBlockedDomain = ()=>{
        if(domainName.length == 0){
            return
        }

        if(!(/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(domainName))) {
            setErrorMessage("Invalid domain name.")
            return
        }

        let bIsDuplicate = false
        for(var i=0;i<blockedDomains.length;i++){
            if(domainName == blockedDomains[i].domain){
                bIsDuplicate = true;
            }
        }

        if(bIsDuplicate) {
            setErrorMessage("Domain name is already present.")
            return
        }

        setErrorMessage("")

        let blockedDomain: Domain = {
            domain: domainName,
            sub_domain: includeSubDomain
        }
        setBlockedDomains([...blockedDomains, blockedDomain])

        setDomainName("")
    }

    const deleteBlockedDomain = (index)=>{
        let arrBlockedDomains = blockedDomains.filter((blockedDomain, i)=> i != index)
        setBlockedDomains(arrBlockedDomains)
    }

    const handleDomainInclude = (domain, subDomain) => {
        setBlockedDomains(prev =>
            prev.map(domainObj =>
            domainObj.domain === domain
                ? { ...domainObj, sub_domain: subDomain }
                : domainObj
            )
        );
    }

    const deleteCSVFile = ()=>{
        let arrBlockedDomains = blockedDomains
        for(let i=0;i<blockedDomains.length;i++){
            for(let j=0;j<csvFileBlockedDomains.length;j++){
                if(csvFileBlockedDomains[j].domain == blockedDomains[i].domain){
                    arrBlockedDomains.splice(i, 1)
                }    
            }
        }
        setBlockedDomains(arrBlockedDomains)
        setBlockedFileName("")
        setBlockedFileSelected(false)
        setCSVFileBlockedDomains([])
    }

    const downloadCSV = ()=>{
        if(blockedDomains.length > 0){
            let downloadedAllowedDomains :any= []
            downloadedAllowedDomains.push(["DOMAIN", "SUB_DOMAIN"])
            
            for(var i=0;i<blockedDomains.length;i++){
                let arr: any= []
                arr.push(blockedDomains[i].domain)
                arr.push(blockedDomains[i].sub_domain)

                downloadedAllowedDomains.push(arr)
            }
            DownloadNamedCSV(downloadedAllowedDomains, "Sample")
        }
    }

    const downloadSampleCSV = ()=>{
        let downloadedAllowedDomains :any= []
        for(var i=0;i<sampleCSVData.length;i++){
            let arr: any= []
            arr.push(sampleCSVData[i].domain)
            arr.push(sampleCSVData[i].sub_domain)

            downloadedAllowedDomains.push(arr)
        }
        DownloadCSV(downloadedAllowedDomains)
    }

    return (
        <>
            <Grid container xs={12} sm={12} md={12} lg={12} className="content-filter-blocked-categoies-div">
                {<TextField
                    style={{ width: "100%" }}
                    variant="outlined"
                    placeholder="Enter Domain Name (EX: 30minutesemail.com)"
                    value={domainName}
                    onChange={onChangeDomainName}
                />}
                {errorMessage.length > 0 ? <span className="domain_name_validation_err_message">{errorMessage}</span> :<></>}
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12} className="content-filter-blocked-categoies-div">
                <Grid item xs={10} sm={10} md={10} lg={10}>
                    <span className="content-filter-domain-name-text">Include Subdomains</span>
                    <AntSwitch checked={includeSubDomain} onChange={onChangeIncludeSubDomain}/>
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2} className="content-filter-add-domain-grid">
                    <Button variant="outlined" startIcon={<AddCircleOutlineIcon/>} className="content_filter--button_outlined_filter" onClick={addBlockedDomain} disabled={domainName.length==0}>
                        Add
                    </Button>
                </Grid>
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12} className="content-filter-blocked-categoies-div">
                <Grid container xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={9} sm={9} md={9} lg={9} className="content-filter-domain-list-count-grid">
                        <span>Domain List: {blockedDomains.length}</span>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3} className="content-filter-add-domain-grid">
                        <Button variant="text" startIcon={<FileDownloadIcon/>} className="content_filter--text-button" onClick={downloadCSV} disabled={blockedDomains.length==0}>
                            Download CSV
                        </Button>
                    </Grid>
                </Grid>
                <TableContainer className="content_filter--domain-names-table_container contentFilterDomainsTableHeight">
                    <Table sx={{ minWidth: 600, maxHeight:200 }} size="small" aria-label="content_filter--service_accounts">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <span>S. No.</span>
                                </TableCell>
                                <TableCell>
                                    <span>Domain Name</span>
                                </TableCell>
                                <TableCell>
                                    <span>Include Sub Domain</span>
                                </TableCell>
                                <TableCell>
                                    <span>Actions</span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody className="tableBody alertsTable-tableBody">
                            {
                                blockedDomains.length == 0 ? 
                                <></>
                                :
                                <>
                                    {
                                        blockedDomains.map((blockedDoamin, index)=>{
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        {index+1}
                                                    </TableCell>
                                                    <TableCell>
                                                        {blockedDoamin.domain}
                                                    </TableCell>
                                                    <TableCell>
                                                        {blockedDoamin.sub_domain ? <> <AntSwitch checked={true} onClick={() => handleDomainInclude(blockedDoamin.domain, false)}/> </> : <> <AntSwitch checked={false} onClick={() => handleDomainInclude(blockedDoamin.domain, true)}/> </>}
                                                    </TableCell>
                                                    <TableCell>
                                                    <IconButton onClick={()=>{deleteBlockedDomain(index)}}>
                                                        <DeleteIcon className="content-filter-delete-icon"/>
                                                    </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12} className="content-filter-blocked-categoies-div content-filter-upload-csv-div">
                <Grid container xs={12} sm={12} md={12} lg={12}>
                    <Grid item xs={7} sm={7} md={7} lg={7}>
                        {
                            blockedfileSelected ? 
                            <>
                            <img src={CSVImg} className="content-filter-csv-image"></img>
                            <span className="content-filter-csv-text">{blockedFileName}</span>
                            </>
                            :
                            <span className="content-filter-csv-text">No CSV Selected</span>
                        }
                    </Grid>
                    <Grid item xs={5} sm={5} md={5} lg={5} className="content-filter-upload-csv-grid">
                        {
                            blockedfileSelected ?
                            <>
                                <span className="content-filter-csv-uploaded-text">Uploaded Successfully</span>
                                <DeleteIcon className="content-filter-delete-icon" onClick={deleteCSVFile}></DeleteIcon>
                            </>
                            :
                            <>
                                <Button variant="text" startIcon={<FileDownloadIcon/>} className="content_filter--text-button" onClick={downloadSampleCSV}>
                                    Sample CSV
                                </Button>
                                <CsvUploader onFileUpload={(file) => handleFileUpload(file, false)}></CsvUploader>
                            </>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    customContentFilter: state.customContentFilter,
})

export default withRouter(
    connect(mapStateToProps, null)(ContentFilterBlockedDomains)
);  